<script>
    import { Select, Option, Form, FormItem, Input, Checkbox, Message } from 'element-ui';
    import { mapState, mapMutations, mapActions } from 'vuex';
    import Vue from 'vue';
    import Loader from '~/components/loader/components/loader';
    import Panel from '~/components/panel/components/panel';
    import VueButton from '~/components/button/components/button';
    import FormGroup from '~/components/form/components/form_group';

    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Checkbox);

    export default {
        components: {
            Loader,
            Panel,
            VueButton,
            FormGroup
        },

        data() {
            return {
                states: [],
                timeZones: []
            }
        },

        computed: {
            ...mapState('newUserRegistrationForm', [
                'formData',
                'lists',
                'loading',
                'stepActive'
            ])
        },

        methods: {
            ...mapActions('newUserRegistrationForm', {
                updateUserAccount: 'updateUserAccount'
            }),

            ...mapMutations('newUserRegistrationForm', {
                updateFormShowingStatus: 'updateFormShowingStatus',
                updateStepStatus: 'updateStepStatus'
            }),

            handleNextClick() {
                this.updateUserAccount()
                .then(response => {
                    if(response.status !== 1) {
                        Message({
                            message: 'Unable to update account',
                            type: 'error'
                        });
                    } else {
                        this.updateFormShowingStatus({
                            formName: 'generalInfoForm',
                            showingStatus: false
                        });

                        this.updateFormShowingStatus({
                            formName: 'imageSettingsForm',
                            showingStatus: true
                        });

                        this.updateStepStatus(2);
                    }
                });
            },

            handlePreviousClick() {
                this.updateFormShowingStatus({
                    formName: 'generalInfoForm',
                    showingStatus: false
                });

                this.updateFormShowingStatus({
                    formName: 'mlsSettingsForm',
                    showingStatus: true
                });

                this.updateStepStatus(0);
            }
        }
    }
</script>
<template>
    <transition
            name="custom-classes-transition"
            enter-active-class="animated fadeInDown"
    >
        <div>
            <div class="row">
                <div class="col-xs-12 col-md-12">
                    <template>
                        <loader :is-loading="loading.updateAccount"></loader>
                        <panel title="Let's add some general information to your profile.">
                            <div slot="body">
                                <div class="row">
                                    <div class="col-xs-12 col-md-12">
                                        <p class="form-text m-b-30">This information will help to provide a detailed description of you when you or your partners create marketing assets within the Total Expert platform.</p>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <el-form
                                                :model="formData"
                                                label-position="top"
                                        >
                                            <el-form-item
                                                    label="First Name"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.f_name"
                                                        name="f_name"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Last Name"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.l_name"
                                                        name="l_name"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Company"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.company"
                                                        name="company"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Address"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.address"
                                                        name="address"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Suite / Unit / Building / Floor / Other"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.address_two"
                                                        name="address_two"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="City"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.city"
                                                        name="city"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="State"
                                            >
                                                <el-select
                                                        v-model="formData.state"
                                                        filterable
                                                        placeholder="Select state"
                                                        name="state"
                                                        auto-complete="on"
                                                >
                                                    <el-option
                                                            v-for="(value, key) in lists.stateList"
                                                            :key="key"
                                                            :label="value"
                                                            :value="key"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Zip Code"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.zipcode"
                                                        name="zipcode"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Job Title"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.job_title"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Office Phone"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.phone_office"
                                                        name="phone_office"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Mobile Phone"
                                                    maxlength="255"
                                            >
                                                <el-input
                                                        v-model="formData.phone_cell"
                                                        name="phone_cell"
                                                        auto-complete="on"
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="Time Zone"
                                            >
                                                <el-select
                                                        v-model="formData.timezone_name"
                                                        clearable
                                                        filterable
                                                        placeholder="Select time zone"
                                                >
                                                    <el-option
                                                            v-for="(value, key) in lists.timeZoneList"
                                                            :key="value"
                                                            :label="key"
                                                            :value="value"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                            <div slot="footer">
                                <div class="row">
                                    <div class="col-xs-12 col-md-12 text-right">
                                        <vue-button type="default" @click="handlePreviousClick">
                                            Previous
                                        </vue-button>
                                        <vue-button type="primary" @click="handleNextClick">
                                            Next
                                        </vue-button>
                                    </div>
                                </div>
                            </div>
                        </panel>
                        <div class="row">
                            <div class="col-xs-12 col-md-12">
                                <div class="registration-form-bottom-area">
                                    <h4>Interested in exploring the Total Expert platform? Click <strong><a href="/login">here</a></strong> to sign in.</h4>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>
<style scoped>
    .registration-form-bottom-area {
        padding: 40px 0;
        text-align: center;
        color: inherit;
    }

    .form-text {
        line-height: 1;
        font-size: 16px;
    }
</style>